export default "__VITE_ASSET__BrSQk694__"